import { Post, Response } from '@/model/post'

const fetchPosts = async (url: string) => {
  try {
    const response = await fetch(url)
    if (response.ok) {
      const { results, next, previous, count }: Response<Post> =
        await response.json()
      const posts = results.map(({ id, name, data, slug, published_date }) => ({
        id,
        name,
        data,
        slug,
        published_date,
      }))
      return {
        posts: posts.length > 0 ? posts : null,
        next: next || null,
        prev: previous || null,
        count: count || 0,
      }
    }
  } catch (e) {}
  return { posts: null, next: null, prev: null, count: 0 }
}

export default fetchPosts
